(() => {
  const money = (cents, currency) => {
    const value = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:currency || 'USD'}).format(value); } catch(e) { return '$' + value.toFixed(2); }
  };
  const num = (value, fallback = 0) => { const n = parseFloat(value); return Number.isFinite(n) ? n : fallback; };
  const initCalculator = (root) => {
    if (!root || root.dataset.heytilesInitialized === 'true') return;
    root.dataset.heytilesInitialized = 'true';
    /* Hey Tiles 2026-10-13: Sink products use the per-piece layout (same as trim) */
    try {
      const productType = String(window.ShopifyAnalytics?.meta?.product?.type || '');
      if (/sink/i.test(productType) && root.dataset.calculatorType !== 'piece') {
        root.dataset.calculatorType = 'piece';
        root.classList.add('heytiles-calculator--piece');
        root.querySelectorAll('.heytiles-calculator__tabs, [data-calc-panel], .heytiles-calculator__results, .heytiles-selected-coverage').forEach((el) => el.remove());
        const h2 = root.querySelector('.heytiles-calculator__header h2');
        const hp = root.querySelector('.heytiles-calculator__header p');
        if (h2) h2.textContent = 'SELECT QUANTITY';
        if (hp) hp.textContent = 'Choose the quantity you need.';
        const ul = root.querySelector('[data-unit-label]');
        if (ul && /^\s*units?\s*$/i.test(ul.dataset.unitSingular || '')) { ul.dataset.unitSingular = 'Piece'; ul.textContent = 'Piece'; }
      }
    } catch (e) {}
    const type = root.dataset.calculatorType || 'area';
    const coverage = Math.max(num(root.dataset.coverage, 1), 0.0001);
    const unitPrice = Math.max(num(root.dataset.unitPrice, 0), 0);
    const currency = root.dataset.currency || 'USD';
    const qty = root.querySelector('.heytiles-unit-quantity');
    const minus = root.querySelector('[data-qty-minus]');
    const plus = root.querySelector('[data-qty-plus]');
    const selectedCoverage = root.querySelector('[data-selected-coverage]');
    const totalPrice = root.querySelector('.heytiles-calculator__total .total_price span');
    const unitLabel = root.querySelector('[data-unit-label]');
    const singular = unitLabel?.dataset.unitSingular || unitLabel?.textContent?.trim() || 'unit';
    let syncCoverageInput = null;
    const minQty = () => Math.max(num(qty?.min || qty?.dataset.min, 1), 1);
    const maxQty = () => { const raw = qty?.max || qty?.dataset.max; return raw ? num(raw, Infinity) : Infinity; };
    const setQty = (value, syncSqft = true, emitChange = true) => {
      if (!qty) return;
      const clamped = Math.min(Math.max(Math.round(num(value, minQty())), minQty()), maxQty());
      qty.value = clamped;
      updatePurchase();
      if (syncSqft) syncCoverageInput?.();
      if (emitChange) qty.dispatchEvent(new Event('change',{bubbles:true}));
    };
    const showBlankQty = () => {
      if (qty) qty.value = '';
      if (selectedCoverage) selectedCoverage.textContent = '0';
      if (totalPrice) totalPrice.textContent = money(0, currency);
      if (unitLabel) unitLabel.textContent = singular;
    };
    const clearLinkedFields = () => {
      if (sqft && active === 'sqft') sqft.value = '';
      showBlankQty();
      recommended = 0;
      if (totalSqft) totalSqft.textContent = '0.00';
      if (unitsNeeded) unitsNeeded.textContent = '0';
    };
    const updatePurchase = () => {
      if (qty && String(qty.value).trim() === '') { showBlankQty(); return; }
      const q = Math.max(num(qty?.value, minQty()), minQty());
      const cleanUnit = String(singular || 'unit').trim();
      const displayUnit = q === 1 ? cleanUnit : (/s$/i.test(cleanUnit) ? cleanUnit : cleanUnit + 's');
      if (selectedCoverage) selectedCoverage.textContent = (q * coverage).toFixed(2).replace(/\.00$/,'');
      if (totalPrice) totalPrice.textContent = money(q * unitPrice, currency);
      if (unitLabel) unitLabel.textContent = displayUnit;
    };
    minus?.addEventListener('click',()=>setQty(num(qty?.value,minQty())-1));
    plus?.addEventListener('click',()=>setQty(num(qty?.value,minQty())+1));
    const handleQtyChange = () => {
      if (String(qty?.value || '').trim() === '') { clearLinkedFields(); return; }
      updatePurchase();
      syncCoverageInput?.();
    };
    qty?.addEventListener('input',handleQtyChange);
    qty?.addEventListener('change',handleQtyChange);
    if (type === 'piece') { updatePurchase(); return; }
    const tabs = [...root.querySelectorAll('[data-calc-tab]')];
    const panels = [...root.querySelectorAll('[data-calc-panel]')];
    const sqft = root.querySelector('.sqfit_quantity_input');
    const waste = root.querySelector('[data-waste-select]');
    const length = root.querySelector('[data-room-length]');
    const width = root.querySelector('[data-room-width]');
    const roomWaste = root.querySelector('[data-room-waste]');
    const totalSqft = root.querySelector('[data-total-sqft]');
    const unitsNeeded = root.querySelector('[data-units-needed]');
    const recommendedUnit = root.querySelector('[data-recommended-unit]');
    const useRecommended = root.querySelector('[data-use-recommended]');
    let active = 'sqft';
    let recommended = minQty();
    syncCoverageInput = () => {
      if (!sqft || active !== 'sqft') return;
      if (String(qty?.value || '').trim() === '') return;
      const q = Math.max(num(qty?.value, minQty()), minQty());
      sqft.value = (q * coverage).toFixed(2).replace(/\.00$/,'');
      calculate();
    };
    const calculate = (syncQtyFromArea = false) => {
      let base = 0, wastePct = 0;
      if (active === 'sqft') { base = Math.max(num(sqft?.value, 0), 0); wastePct = Math.max(num(waste?.value, 0), 0); }
      else if (active === 'room') { base = Math.max(num(length?.value, 0), 0) * Math.max(num(width?.value, 0), 0); wastePct = Math.max(num(roomWaste?.value, 0), 0); }
      else { base = Math.max(num(qty?.value, minQty()), minQty()) * coverage; wastePct = 0; }
      const total = base * (1 + wastePct / 100);
      recommended = Math.max(Math.ceil(total / coverage), minQty());
      if (totalSqft) totalSqft.textContent = total.toFixed(2);
      if (unitsNeeded) unitsNeeded.textContent = recommended;
      if (recommendedUnit) recommendedUnit.textContent = singular;
      if (syncQtyFromArea && active !== 'manual') setQty(Math.max(Math.ceil(base / coverage), minQty()), false, false);
      else updatePurchase();
    };
    tabs.forEach(tab => tab.addEventListener('click',() => {
      active = tab.dataset.calcTab || 'sqft';
      tabs.forEach(t => { const on = t === tab; t.classList.toggle('is-active',on); t.setAttribute('aria-selected',on ? 'true' : 'false'); });
      panels.forEach(panel => { const on = panel.dataset.calcPanel === active; panel.hidden = !on; panel.classList.toggle('is-active',on); });
      calculate();
    }));
    const resetQtyIfSqftEmpty = () => {
      if (!sqft || String(sqft.value).trim() !== '') return false;
      clearLinkedFields();
      return true;
    };
    sqft?.addEventListener('input', () => { if (resetQtyIfSqftEmpty()) return; calculate(true); });
    sqft?.addEventListener('change', () => { if (resetQtyIfSqftEmpty()) return; calculate(true); });
    [waste,length,width,roomWaste].forEach(el => { el?.addEventListener('input',()=>calculate(true)); el?.addEventListener('change',()=>calculate(true)); });
    useRecommended?.addEventListener('click',()=>setQty(recommended || minQty(), false));
    updatePurchase();
    calculate();
  };
  const initAll = (scope=document) => { scope.querySelectorAll?.('[data-heytiles-calculator]').forEach(initCalculator); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initAll()); else initAll();
  document.addEventListener('shopify:section:load',e=>initAll(e.target));
  document.addEventListener('variant:change',()=>setTimeout(()=>initAll(),0));
  document.addEventListener('product-info:loaded',()=>setTimeout(()=>initAll(),0));
})();
